import React, { Component } from 'react'
import propTypes from 'prop-types'
import {get} from 'lodash'
import ListEditor from './listEditor'

class BooleanEditor extends Component {
  render () {
    const { open, anchor, value, options, onCommit, onCancel, ...otherProps } = this.props

    const trueLabel = get(options, 'trueLabel', 'Yes')
    const falseLabel = get(options, 'falseLabel', 'No')

    const values = [
      { key: true, label: trueLabel },
      { key: false, label: falseLabel },
    ]

    return <ListEditor open={open} value={value} anchor={anchor} {...otherProps} onCommit={onCommit} onCancel={onCancel} values={values} />
  }
}

BooleanEditor.propTypes = {
  value: propTypes.any, // to match values[].key
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  options: propTypes.shape({
    trueLabel: propTypes.string,
    falseLabel: propTypes.string,
  }),
  onCommit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
}

export default BooleanEditor
